class BrowserBack extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', () => {
      this.goBack()
    })
  }

  goBack () {
    const event = new CustomEvent('browser-back:click', {
      cancelable: true,
      bubbles: true,
    })
    document.dispatchEvent(event)

    if (event.defaultPrevented) return

    history.go(-1)
  }
}

if (!customElements.get('browser-back')) {
  customElements.define('browser-back', BrowserBack)
}
